import { render, staticRenderFns } from "./VideoContent.vue?vue&type=template&id=00fa09fa&"
import script from "./VideoContent.vue?vue&type=script&lang=js&"
export * from "./VideoContent.vue?vue&type=script&lang=js&"
import style0 from "./VideoContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VideoContent.vue"
export default component.exports